import IconName from "../types/IconName";

const iconNames = Object.entries(IconName).map(([,iconName]) => iconName);

export default iconNames